import styled from "@emotion/styled";
import { Badge, Box } from "@mui/material";
import { FC, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const StyledPhoto = styled.img`
    width: 70px;
    height: 70px;
    object-fit: contain;
`;

const SlidesViewer = styled.div<{ slidesLength: number }>`
    display: flex;
    overflow: auto;

    ${({slidesLength}) => slidesLength < 8 && `
        justify-content: center;
    `}

    @media screen and (max-width: 940px){
        display: none;
    }
`

const CustomBadge = styled(Badge)`
    @media screen and (min-width: 940px){
        display: none;
    }

`

interface ImageComponentProps {
    photos: any[];
}

const ImageComponent: FC<ImageComponentProps> = ({
    photos,
}) => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const toggleOpen = (state: boolean) => () => setOpen(state);

    const updateIndex = ({ index: current }: { index: number }) =>
        setIndex(current);

    const slides = photos?.flatMap(photoObj => photoObj.photo).map(photoUrl => ({ src: photoUrl }));

    return (
        <>
            <CustomBadge
                sx={{
                    position: 'absolute',
                    right: 30,
                }}
                badgeContent={`${index !== undefined ? index + 1 : 1}/${slides?.length}`}
                color="primary"
            />
            <Lightbox
                styles={{ container: { backgroundColor: "rgba(255, 255, 255, 0.8)" } }}
                index={index}
                slides={slides}
                plugins={[Inline]}
                on={{
                    view: updateIndex,
                    click: toggleOpen(true),
                }}
                carousel={{
                    padding: 0,
                    spacing: 0,
                    imageFit: "contain",
                }}
                inline={{
                    style: {
                        maxHeight: "55vh",
                        width: "100%",
                        aspectRatio: "3 / 2",
                        margin: "0 auto",
                        cursor: 'pointer'
                    },
                }}
            />
            <SlidesViewer
                slidesLength={slides?.length}
            >
                {slides.map((slide, index2) => (
                    <Box
                        sx={{
                            m: '2px',
                            mt: 1,
                            p: '7px',
                            borderRadius: 2,
                            cursor: 'pointer',
                            backgroundColor: index2 === index ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                                transform: 'scale(1.05)',
                                transition: 'all 0.2s ease-in-out',
                            },
                        }}
                        key={index2}
                        onClick={() => { setIndex(index2); }}
                    >
                        <StyledPhoto src={slide.src} alt="furniture" />
                    </Box>
                ))}
            </SlidesViewer>
            <Lightbox
                plugins={[Zoom]}
                open={open}
                close={toggleOpen(false)}
                index={index}
                slides={slides}
                on={{ view: updateIndex }}
                animation={{ fade: 0 }}
                controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
            />
        </>
    )
}

export default ImageComponent;